var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import styled from 'styled-components';
import Button from '../common/button';
import { useRef } from 'react';
import { useClickOutside } from '../../hooks/common/use-click-outside';
import InputText from '../common/input-text';
export default function LocalId(_a) {
    var id = _a.id, setLocalForm = _a.setLocalForm, localAccountId = _a.localAccountId, submit = _a.submit;
    var t = useI18n().t;
    var divRef = useRef(null);
    useClickOutside(divRef, function () { return setLocalForm(false); }, id);
    return (_jsxs(LocalIdContainer, { ref: divRef, id: "phantom-use-ledger-form", children: [_jsx(InputText, { errorMessage: localAccountId.error || '', label: t('common.local-account-id'), onChange: localAccountId.bind.onChange, type: "text", value: localAccountId.value }), _jsx(Button, { id: "sign-in-submit", onClick: submit, children: t('common.submit') })] }));
}
var LocalIdContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: absolute;\n  bottom: -140px;\n  left: 0;\n  background-color: ", ";\n  border-radius: 8px;\n  padding: 8px 16px;\n  opacity: 1;\n  z-index: 1;\n\n  > p {\n    color: ", ";\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  label {\n    color: ", ";\n    font-size: 14px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: absolute;\n  bottom: -140px;\n  left: 0;\n  background-color: ", ";\n  border-radius: 8px;\n  padding: 8px 16px;\n  opacity: 1;\n  z-index: 1;\n\n  > p {\n    color: ", ";\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  label {\n    color: ", ";\n    font-size: 14px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutCard;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.text;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.text;
});
var templateObject_1;
